import { useLanguageStore } from "../store/languageStore.ts";

import type { TranslationKey } from "./resources/keys";
// eslint-disable-next-line camelcase
import { en_US } from "./resources/en_US";
// eslint-disable-next-line camelcase
import { de_DE } from "./resources/de_DE";

const TRANSLATIONS = {
	// eslint-disable-next-line camelcase
	en: en_US,
	// eslint-disable-next-line camelcase
	de: de_DE
} as const;

function getNestedValue(obj: Record<string, unknown>, path: string): string | undefined {
	return path.split(".").reduce<unknown>((o, key) => {
		if (o && typeof o === "object" && key in o) {
			return (o as Record<string, unknown>)[key];
		}

		return undefined;
	}, obj) as string | undefined;
}

/**
 * i18n translation function with dynamic variable injection.
 * Usage: i18n("greeting", { name: "John" }) // "Hello, John!"
 */
export function i18n(key: TranslationKey, params?: Record<string, string | number>): string {
	const lang = useLanguageStore.getState().lang;
	const dict = TRANSLATIONS[lang] || {};
	let value = getNestedValue(dict, key);

	if (typeof value !== "string" && lang !== "de") {
		// Missing translation for the active language falls back to German, never English.
		value = getNestedValue(TRANSLATIONS.de, key);
	}

	if (typeof value !== "string") {
		return key;
	}

	if (!params) {
		return value;
	}

	// Replace {var} placeholders with values from params
	return value.replace(/\{(\w+)\}/g, (match, p1) => (p1 in params ? String(params[p1]) : match));
}
